import {RequestType, UyapRequest} from "./UyapRequest";
import {MtsHarcListCevap} from "@/plugins/uyap-plugin/uyap/MtsHarcList";

export interface MtsHarcListDosyaIdTalep {
    dosyaId: any
}

export default class MtsHarcListDosyaId extends UyapRequest<MtsHarcListDosyaIdTalep, MtsHarcListCevap> {
    getMethod(): 'GET' | 'POST' {
        return 'POST';
    }

    getSpinnerMessage(){
        return "MTS harç listesi dosya ID ile sorgulanıyor...";
    }


    cache() {
        return {
            active: false,
            ttl: (60 * 24), //* 1 gun
            key: "_"
        };
    }

    getMockResponse(): any {
        return [
            {
                "harcmasrafKodStr": 144205,
                "harcmasrafBedelmiOranmi": "O",
                "harcMasrafOran": 2,
                "hesapMiktar": 6291.35,
                "ekranID": 9,
                "pesinHarcDusulsunmu": "H",
                "harcMasrafAltSiniri": 615.4,
                "hmDurumu": 0,
                "hmAktif": false,
                "isSatirDegisecek": false,
                "harcMasrafKod": 63266,
                "harcMasrafAdi": "MTS Harcı",
                "aciklama": "Mts Harcı",
                "baslangicHarci": "E",
                "harcMasraf": "H",
                "harcTip": 34,
                "gv_tabi": 0,
                "dv_tabi": 0,
                "yg_tabi": 0,
                "makbuzTipi": 1
            },
            {
                "harcmasrafKodStr": 144200,
                "harcmasrafBedelmiOranmi": "B",
                "harcMasrafBedel": 87.5,
                "hesapMiktar": 87.5,
                "ekranID": 9,
                "pesinHarcDusulsunmu": "H",
                "hmDurumu": 0,
                "hmAktif": false,
                "isSatirDegisecek": false,
                "harcMasrafKod": 12809,
                "harcMasrafAdi": "Vekalet Suret Harcı",
                "aciklama": "Vekaletname Suret Harcıdır",
                "baslangicHarci": "E",
                "harcMasraf": "H",
                "harcTip": 14,
                "gv_tabi": 0,
                "dv_tabi": 0,
                "yg_tabi": 0,
                "makbuzTipi": 1
            }
        ];
    }

    getUrl(): string {
        return this.ImzaClientAddr + 'mtHarcListDosyaid_brd.ajx';
    }

    getRequestType(): RequestType {
        return "json";
    }

    async parse(data: any): Promise<MtsHarcListCevap> {
        try {
            if (data && typeof data.error !== 'undefined') {
                throw new Error(data.error);
            }
            let toplam = 0;
            data.forEach((val: any) => {
                toplam += val.hesapMiktar;
            })
            return {
                //@ts-ignore
                data: data,
                toplam: toplam
            };
        } catch (e) {
            throw new Error(e.message);
        }
    }


}

